(function () {
  if (typeof Swiper === 'undefined') return;

  document.querySelectorAll('.cozy-reviews--swiper').forEach(function (el) {
    if (el.classList.contains('swiper-initialized')) return;

    new Swiper(el, {
      wrapperClass: 'cozy-reviews--list',
      slideClass: 'cozy-reviews--item',
      slidesPerView: 1,
      spaceBetween: 16,
      loop: false,
      breakpoints: {
        1024: {
          slidesPerView: 3,
          spaceBetween: 100,
        },
      },
    });
  });
})();
